<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <section class="footer-information" aria-label="联盟联系信息">
        <div class="contact-grid">
          <p><span>联盟地址</span>北京市海淀区车公庄西路33号人民画报社8号楼439室</p>
          <p><span>联系电话</span><a href="tel:18612317646">18612317646</a></p>
          <p><span>联盟邮箱</span><a href="mailto:betc@cxfwlm.org.cn">betc@cxfwlm.org.cn</a></p>
        </div>
        <div class="footer-divider"></div>
        <p class="copyright">北京企业技术中心创新服务联盟 版权所有</p>
        <p class="operator">© 北京软件和信息服务交易所有限公司 承办</p>
        <div class="filing-row" aria-label="网站备案信息">
          <span class="filing-item"><i class="security-icon">盾</i>京公网安备 110105000722号</span>
          <a class="filing-item" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备05060933号</a>
        </div>
      </section>

      <section class="qrcode-grid" aria-label="联盟二维码">
        <figure>
          <img src="../assets/image/leftcode.png" alt="北京企业技术中心创新服务联盟订阅号二维码" loading="lazy" decoding="async">
          <figcaption><strong>订阅号</strong><span>北京企业技术中心<br>创新服务联盟</span></figcaption>
        </figure>
        <figure>
          <img src="../assets/image/rightcode.png" alt="联盟官方微信二维码" loading="lazy" decoding="async">
          <figcaption><strong>联盟官方微信</strong><span>联系人：朱赛男<br><a href="tel:18612317646">18612317646</a></span></figcaption>
        </figure>
      </section>
    </div>
  </footer>
</template>

<script>
export default { name: "SiteFooter" };
</script>

<style scoped>
.site-footer { box-sizing: border-box; width: 100%; padding: 34px 24px 30px; color: #eef4f8; background: linear-gradient(135deg, #26333d 0%, #30373c 48%, #252c31 100%); }
.footer-inner { display: grid; grid-template-columns: minmax(0, 1fr) 330px; gap: 54px; width: min(1180px, 100%); margin: 0 auto; align-items: center; }
.footer-information { min-width: 0; text-align: left; }
.contact-grid { display: grid; grid-template-columns: minmax(300px, 1.6fr) minmax(160px, .7fr) minmax(220px, 1fr); gap: 16px 28px; }
.contact-grid p { display: flex; min-width: 0; margin: 0; color: #d9e2e8; font-size: 13px; line-height: 1.7; }
.contact-grid span { flex: 0 0 auto; margin-right: 10px; color: #8fbfd6; font-weight: 600; }
.site-footer a { color: inherit; text-decoration: none; overflow-wrap: anywhere; }
.site-footer a:hover { color: #62c4ee; }
.footer-divider { height: 1px; margin: 24px 0 19px; background: linear-gradient(90deg, rgba(125,190,218,.5), rgba(255,255,255,.08)); }
.copyright,.operator { margin: 0; font-size: 13px; line-height: 1.8; }
.copyright { color: #f5f8fa; font-weight: 600; }
.operator { color: #aebcc5; }
.filing-row { display: flex; flex-wrap: wrap; gap: 10px 22px; margin-top: 16px; color: #c3cfd6; font-size: 12px; line-height: 24px; }
.filing-item { display: inline-flex; align-items: center; white-space: nowrap; }
.security-icon { display: inline-flex; width: 20px; height: 20px; margin-right: 7px; align-items: center; justify-content: center; border-radius: 50%; color: #dff5ff; background: #247da5; font-size: 9px; font-style: normal; }
.qrcode-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 28px; }
.qrcode-grid figure { margin: 0; text-align: center; }
.qrcode-grid img { display: block; width: 116px; height: 116px; margin: 0 auto 10px; padding: 6px; border-radius: 6px; background: #fff; object-fit: contain; box-shadow: 0 8px 24px rgba(0,0,0,.18); }
.qrcode-grid figcaption { display: flex; flex-direction: column; gap: 5px; font-size: 12px; line-height: 1.55; }
.qrcode-grid strong { color: #fff; font-size: 13px; }
.qrcode-grid span { color: #b9c7cf; }

@media (max-width: 980px) {
  .footer-inner { grid-template-columns: 1fr; gap: 28px; }
  .contact-grid { grid-template-columns: 1fr 1fr; }
  .contact-grid p:first-child { grid-column: 1 / -1; }
  .qrcode-grid { width: min(340px, 100%); margin: 0 auto; }
}

@media (max-width: 600px) {
  .site-footer { padding: 28px 18px; }
  .contact-grid { grid-template-columns: 1fr; gap: 9px; }
  .contact-grid p:first-child { grid-column: auto; }
  .contact-grid p { display: block; }
  .contact-grid span { display: block; margin: 0 0 2px; }
  .filing-row { display: grid; gap: 6px; }
  .filing-item { white-space: normal; }
  .qrcode-grid { gap: 16px; }
  .qrcode-grid img { width: 104px; height: 104px; }
}
</style>
